import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Fapugo Barbershop</h3>
          <p>
            Το κορυφαίο κουρείο για σύγχρονο ανδρικό στυλ και επαγγελματική
            περιποίηση. Εμπιστευτείτε την εμπειρία μας για την τέλεια εμφάνιση.
          </p>
        </div>

        <div className="footer-section">
          <h3>Γρήγορες Συνδέσεις</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">Αρχική</Link>
            </li>
            <li>
              <Link to="/about">Σχετικά με εμάς</Link>
            </li>
            <li>
              <Link to="/contact">Επικοινωνία</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Όροι Χρήσης</Link>
            </li>
            <li>
              <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Επικοινωνία</h3>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FaHome style={{ color: "#b87333" }} />
              <span>Kolokotronis 23, Gazi 715 00, Greece</span>
            </div>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FaPhone style={{ color: "#b87333" }} />
              <span>+302816007086</span>
            </div>
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FaEnvelope style={{ color: "#b87333" }} />
              <span>
                <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
              </span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Κοινωνικά Δίκτυα</h3>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}
          >
            <a className="social-link" href="https://wa.me/302816007086">WhatsApp</a>
            <a className="social-link" href="https://viber.me/302816007086">Viber</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; 2026 Fapugo Barbershop. Όλα τα δικαιώματα κατοχυρωμένα. ΑΦΜ:
          51604280
        </p>
      </div>
    </footer>
  );
}

export default Footer;
